
var Mediator = require('./Mediator.js');

/**
 * 管理图层相关操作
 */
var LayerManager = {

  stylePicker: null,

  addLayer: function (obj) {
    $(Mediator.getCanvas()).addLayer(obj).drawLayers();
    return obj.data.cid;
  },

  getBindLayers: function (layer) {
    var results = [];
    if(!layer) {
      return [];
    }
    if (layer.data.tool !== 'TextTool') {
      return [layer];
    }
    var layers = $(Mediator.getCanvas()).getLayers();
    for (var i = 0; i < layers.length; i++) {
      var l = layers[i];
      if (l.data.tool !== layer.data.tool) {
        continue;
      }
      if (l.data.bindId === layer.data.bindId) {
        results[l.data.relativeIndex] = l;
      }
    }
    return results;
  },

  deleteLayer: function (layer) {
    var ids = [];
    if (layer) {
      var relativeLayers = this.getBindLayers(layer);
      //从外层往里删除，避免里面层删除后造成的索引错位
      for (var i = relativeLayers.length-1; i >= 0; i--) {
        var l = relativeLayers[i];
        ids.push(l.data.id);
        $(Mediator.getCanvas()).removeLayer(l.index);
      }
      $(Mediator.getCanvas()).drawLayers();
    }
    return ids;
  },
  hiddenLayer: function(layer) {
    var relativeLayers = this.getBindLayers(layer);
    for(var i=0;i<relativeLayers.length;i++) {
      relativeLayers[i].visible = false;
    }
    $(Mediator.getCanvas()).drawLayers();
  },
  showLayer: function(layer) {
    var relativeLayers = this.getBindLayers(layer);
    for(var i=0;i<relativeLayers.length;i++) {
      relativeLayers[i].visible = true;
    }
    $(Mediator.getCanvas()).drawLayers();
  },
  setVisible: function(isVisible) {
    $(Mediator.getCanvas()).setLayers({visible: isVisible});
    $(Mediator.getCanvas()).drawLayers();
  },
  clearAll: function () {
    $(Mediator.getCanvas()).removeLayers();
    $(Mediator.getCanvas()).drawLayers();
  },

  clearSelf: function() {
    var layers = $(Mediator.getCanvas()).getLayers();
    var index = [];
    for(var i=layers.length-1;i>=0;i--) {
      var layer = layers[i];
      if(layer.data.author !== Mediator.getAuthor()) {
        continue;
      }
      index.push({index: layer.index, id: layer.data.id});
    }
    //从大到小排序
    index.sort(function(a,b){
      return b.index-a.index;
    });
    var result = [];
    for(var i=0;i<index.length;i++) {
      result.push(index[i].id);
      $(Mediator.getCanvas()).removeLayer(index[i].index);
    }
    return result;
  },

  clearPoints: function () {
    $(Mediator.getCanvas()).removeLayerGroup('points').drawLayers();
  },

  isClearable: function() {
    var layers = $(Mediator.getCanvas()).getLayers();
    for(var i=0;i<layers.length;i++) {
      var layer = layers[i];
      if(layer.data.author === Mediator.getAuthor()) {
        return true;
      }
    }
    return false;
  },

  getCid: function() {
    var cid = -1;
    var layers = $(Mediator.getCanvas()).getLayers();
    for(var i=0;i<layers.length;i++) {
      var layer = layers[i];
      if(layer.data.cid > cid) {
        cid = layer.data.cid;
      }
    }
    cid++;
    return cid;
  },

  getLayerByCid: function(layerCid) {
    var layers = $(Mediator.getCanvas()).getLayers();
    for(var i=0;i<layers.length;i++) {
      var layer = layers[i];
      if(layer.data.cid === layerCid) {
        return layer;
      }
    }
    return null;
  },

  getCursorStyle: function(layer) {
    if(layer.name === 'pointBegin' || layer.name === 'pointEnd') {
      return 'pointer';
    }
    var pointLeftTop = $(Mediator.getCanvas()).getLayer('pointLeftTop');
    var pointRightTop = $(Mediator.getCanvas()).getLayer('pointRightTop');
    var pointLeftBottom = $(Mediator.getCanvas()).getLayer('pointLeftBottom');
    var dx = pointRightTop.x - pointLeftTop.x;
    var dy = pointLeftBottom.y - pointLeftTop.y;
    var isReverse = false;
    if(dx*dy < 0) {
      isReverse = true;
    }
    if(layer.name === 'pointLeft' || layer.name === 'pointRight') {
      return 'ew-resize';
    } else if(layer.name === 'pointTop' || layer.name === 'pointBottom'){
      return 'ns-resize';
    } else if(layer.name === 'pointLeftTop' || layer.name === 'pointRightBottom'){
      if(isReverse) {
        return 'nesw-resize'
      } else {
        return 'nwse-resize'
      }
    } else if(layer.name === 'pointRightTop' || layer.name === 'pointLeftBottom') {
      if(isReverse) {
        return 'nwse-resize';
      } else {
        return 'nesw-resize';
      }
    }
  },
  flipPoints: function(checkPoint, axis) {
    var points = $(Mediator.getCanvas()).getLayerGroup('points');
    var pName = checkPoint.name;
    var key;
    if(axis === 'LR') {
      if(pName.indexOf('Left') !== -1) {
        key = pName.replace('Left', 'Right');
      }
      if(pName.indexOf('Right') !== -1) {
        key = pName.replace('Right', 'Left');
      }
    }
    if(axis === 'TB') {
      if(pName.indexOf('Top') !== -1) {
        key = pName.replace('Top', 'Bottom');
      }
      if(pName.indexOf('Bottom') !== -1) {
        key = pName.replace('Bottom', 'Top');
      }
    }
    if(key) {
      for(var i=0;i<points.length;i++) {
        if(points[i].name === key) {
          return points[i];
        }
      }
    }
  },

  drawPoint: function (objs) {
    this.clearPoints();
    for (var i = 0; i < objs.length; i++) {
      $(Mediator.getCanvas()).addLayer(objs[i]);
    }
    $(Mediator.getCanvas()).drawLayers();
  },

  isOnArrow: function(x, y) {
    var lineLayers = $(Mediator.getCanvas()).getLayers();
    for(var i=lineLayers.length-1;i>=0;i--) {
      var layer = lineLayers[i];
      if(layer.data.tool === 'ArrowTool') {
        if(this.isClearLine(layer, x, y)) {
          return layer;
        }
      }
      if (layer.groups[0] === 'points') {
        if(this.isClearPoint(layer, x, y)) {
          return layer;
        }
      }
    }
    return null;
  },

  isClearPoint: function (layer, x, y) {
    if(Math.sqrt(Math.pow(layer.x-x, 2) + Math.pow(layer.y-y, 2)) < 10) {
      return true;
    }
    return false;
  },

  isClearLine: function(layer, x, y) {
    //先求出箭头首尾两点构成的直线
    var k = (layer.y2-layer.y1)/(layer.x2-layer.x1);
    var b = layer.y1 - layer.x1 * k;

    var d = Math.abs((k * x - y + b)/Math.sqrt(Math.pow(k, 2)+1));
    var minX = Math.min(layer.x1, layer.x2);
    var minY = Math.min(layer.y1, layer.y2);
    var maxX = Math.max(layer.x1, layer.x2);
    var maxY = Math.max(layer.y1, layer.y2);
    if(d < layer.strokeWidth+10 && x < maxX && x > minX && minY < y && maxY > y) {
      return true;
    }
    return false;
  }

};

module.exports = LayerManager;


// WEBPACK FOOTER //
// ./src/helper/Review/LayerManager.js